import React from 'react';

export const STATUS_LIST = [
  'Draft','Ready to Send','Sent',
  'Response Received','Under Analysis','In Negotiation',
  'Approved','Rejected'
];

export const STATUS_PT = {
  'Draft':             'Rascunho',
  'Ready to Send':     'Pronta p/ Envio',
  'Sent':              'Enviada',
  'Response Received': 'Resposta Recebida',
  'Under Analysis':    'Em Análise',
  'In Negotiation':    'Em Negociação',
  'Approved':          'Aprovada',
  'Rejected':          'Recusada',
};

export const STATUS_META = {
  'Draft':             { emoji:'📝', cls:'draft' },
  'Ready to Send':     { emoji:'📋', cls:'ready' },
  'Sent':              { emoji:'📤', cls:'sent' },
  'Response Received': { emoji:'📥', cls:'received' },
  'Under Analysis':    { emoji:'🔍', cls:'analysis' },
  'In Negotiation':    { emoji:'💬', cls:'negotiation' },
  'Approved':          { emoji:'✅', cls:'approved' },
  'Rejected':          { emoji:'❌', cls:'rejected' },
};

export const ORDER_STATUS_LIST = [
  'Order Placed',
  'Sample Sent',
  'Sample Approved',
  'In Production',
  'Quality Check',
  'Shipped',
  'In Customs',
  'Delivered',
];

export const ORDER_STATUS_META = {
  'Order Placed':    { emoji:'📦', cls:'ordered' },
  'Sample Sent':     { emoji:'📬', cls:'sent' },
  'Sample Approved': { emoji:'✅', cls:'approved' },
  'In Production':   { emoji:'🏭', cls:'analysis' },
  'Quality Check':   { emoji:'🔍', cls:'analysis' },
  'Shipped':         { emoji:'🚢', cls:'negotiation' },
  'In Customs':      { emoji:'🛃', cls:'received' },
  'Delivered':       { emoji:'🎉', cls:'approved' },
};

export const ORDER_STATUS_PT = {
  'Order Placed':    'Pedido Gerado',
  'Sample Sent':     'Amostra Enviada',
  'Sample Approved': 'Amostra Aprovada',
  'In Production':   'Em Produção',
  'Quality Check':   'Controle de Qualidade',
  'Shipped':         'Embarcado',
  'In Customs':      'Em Alfândega',
  'Delivered':       'Entregue',
};

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || { emoji:'•', cls:'draft' };
  return <span className={`badge badge-${meta.cls}`}>{meta.emoji} {STATUS_PT[status]||status}</span>;
}

export function PriorityBadge({ priority }) {
  const labels = { HIGH:'🔴 Alta', MEDIUM:'🟡 Média', LOW:'⚪ Baixa' };
  return <span className={`priority-${priority||'MEDIUM'}`}>{labels[priority]||'🟡 Média'}</span>;
}

export const PRIORITY_OPTIONS = ['HIGH','MEDIUM','LOW'];
export const NEGOTIATION_STATUS_OPTIONS = ['Novo','Contatado','Em Sampling','Ativo','Em Pausa','Inativo'];

export function fmtBRL(v) {
  if (!v && v!==0) return '—';
  return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(v);
}
export function fmtUSD(v) {
  if (!v && v!==0) return '—';
  return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(v);
}
export function fmtRMB(v) {
  if (!v && v!==0) return '—';
  return '¥' + new Intl.NumberFormat('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}).format(v);
}
export function fmtPct(v) {
  if (v == null || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('pt-BR',{minimumFractionDigits:0,maximumFractionDigits:2}).format(n) + '%';
}
export function fmtDate(d) {
  if (!d) return '—';
  const s = String(d);
  // 'YYYY-MM-DD' é data de calendário, não instante. `new Date('2026-11-20')`
  // é interpretado como UTC-meia-noite e, em fuso negativo (Brasil, UTC-3),
  // volta para o dia 19 — a entrega prevista aparecia um dia antes. Formatamos
  // direto, sem passar por Date.
  const onlyDate = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (onlyDate) return `${onlyDate[3]}/${onlyDate[2]}/${onlyDate[1]}`;
  const dt = new Date(s);
  return Number.isNaN(dt.getTime()) ? '—' : dt.toLocaleDateString('pt-BR');
}
export function totalDays(item, shipping, customs) {
  return (item.sampling_days||0)+(shipping||0)+(item.production_days||0)+(customs||0);
}
export function calcItemUSD(item, rmbRate, currency) {
  const price = item.target_price || 0;
  const priceUSD = (currency === 'RMB') ? price / (rmbRate || 6.7) : price;
  return priceUSD * (item.quantity || 0);
}
export function calcItemBRL(item, exchangeRate, multiplier, rmbRate, currency) {
  const priceUSD = calcItemUSD(item, rmbRate, currency);
  return priceUSD * (exchangeRate||5.2) * (multiplier||1.6);
}
